////////////////OrderConfig.js

import g from '@/model/language'
import { IsRights, Modulel, Permission, Clone, ToComponentData, ToSubmitEntity, CheckByConfig, ToSubmitData, CheckByEntity, $Urlpath } from '@/config/config'
import { OrderRequest } from '@/request/Order'
import { ChannelInfoRequest } from '@/request/Channel'
import { ShopCustomerRequest } from '@/request/ShopCustomer'
import ExpandComponent from '@/frame/Order/OrderTableExpandComponent1.vue'
import { RegionRequest } from '@/request/Region'
import { WarehouseRequest } from '@/request/Warehouse'
import { ColorMarkRequest } from '@/request/ColorMark'

import '@/lf'
import { ObjectCheck } from '@/lf'

export function InitOrderPage(StoreName, GNFunc) {

    var dc = { data: {} };

    var defaultStoreName = 'OrderPage'
    if (StoreName) {
        defaultStoreName = StoreName;
    }

    var GN = function(storeName) {
        return defaultStoreName + '$' + storeName;
    }
    //发货时间
    // GetMonth("-3")
    function GetMonth(month) {
        var time = new Date(); 
        var y = time.getFullYear();
        var m = time.getMonth() +1 + month; //获取当前月份的日期
        var d = time.getDate();

        if(m<1){
            y = y-1;
            m= 12 + m
        }

        time.setDate(time.getDate()); //获取Day天后的日期
        // return y + "-" + m + "-" + d;
        return new Date(y+'-'+m+'-'+d)
      }

    if (GNFunc) {
        GN = GNFunc;
    }

    defaultStoreName = GN('OrderPage')
    var vueObj = window.rootVue;
    var vueState = vueObj.$store.state;
    var state = vueObj.$store.state[defaultStoreName];


    var OrderPage = {
        Title: g('$订单列表'),
        storeName: defaultStoreName,
        GN: GN,
        AddModuleShow: false,
        AddModuleShow2: false,
        AddModuleShow5:false,//多选状态订单弹框
        ShouBtnExport:false,//选择导出列
        tableColumns: [], // 表格列定义
        selectedColumns: [], // 用户选择的导出列
        columns: [], // 从接口获取的所有列数据
        orders:'',//拦截单号字符串
        AddModalName: g('$新建订单'),
        IsInit: false,
        Search: //page-search-table 配置
            [
            { nickName: g('$参考号'), field: 'CsRefNo', type: 'String', error: '' },
            { nickName: g('$客户ID'), field: 'CusCode', type: 'String', error: '' },
            { nickName: g('$收件人'), field: 'ConsigneeName', type: 'String', error: '' },
            { nickName: g('$国家'), field: 'CountryList', type: 'Select',IsMultiple:true,  error: '', forSelectStoreName: GN('OrderCountry') },
            {
                nickName: g('$渠道'),
                field: 'ChannelInfoIDList',
                type: 'Select',
                IsMultiple:true, 
                error: '',
                forSelectStoreName: GN('OrderChannelInfoID')
                    // ,OnChange (d){
                    //     if (state.ToChannelInfoChange) {
                    //         state.ToChannelInfoChange(d)
                    //     }
                    // }
            },

            { nickName: g('$下家'), field: 'SubChannelInfoIDList', type: 'Select',IsMultiple:true,  error: '', forSelectStoreName: GN('OrderSubChannelInfoID') },
            { nickName: g('$仓库'), field: 'WarehouseID', type: 'Select', error: '', forSelectStoreName: GN('OrderWareHousesID') },
            // { nickName: g('$SKU'), field: 'SKU', type: 'String', error: '' },

            { nickName: g('$创建时间'), field: 'StartCreateTime', initValue: GetMonth(-3), type: 'DateTimePicker', error: '' },
            { nickName: g('$至'), field: 'EndCreateTime', type: 'DateTimePicker', error: '' },

            { nickName: g('$收货时间'), field: 'StartReceiveTime', type: 'DateTimePicker', error: '' },
            { nickName: g('$至'), field: 'EndReceiveTime', type: 'DateTimePicker', error: '' },

            { nickName: g('$发货时间'), field: 'StartDeliveryTime',  type: 'DateTimePicker', error: '' },
            { nickName: g('$至'), field: 'EndDeliveryTime', type: 'DateTimePicker', error: '' },
            { nickName: g('$平台Sku'), field: 'ShopSKU', type: 'String', error: '' },
            { nickName: g('$排序'), field: 'Sort', type: 'Select', error: '', initValue: 0, forSelectStoreName: ('OrderSort') },
            { nickName: g('$颜色'), field: 'LevelMark', type: 'Select', error: '', forSelectStoreName: GN('ColorMark') },
            { nickName: g('$运输状态'), field: 'AfterShiptag', type: 'Select', error: '', initValue: "", forSelectStoreName: ('DeveliverType') },

            {
                nickName: g('$店铺'),
                field: 'ShopName',
                type: 'Autocomplete',
                error: '',
                Filter(queryString) {


                    return (restaurant) => {
                        return (restaurant.Value.toLowerCase().indexOf(queryString.toLowerCase()) != -1);
                    };
                },
                forSelectStoreName: GN('OrderShopCustomerID'),
                LableField: 'Value',
                ValueField: 'Value'
            },
            { nickName: g('$是否自动拉单'), field: 'ShopPostBackID', type: 'Select', error: '', initValue: "", forSelectStoreName: ('IsAutoGetOrderFlag') },
            { nickName: g('$订单类型'), field: 'OrderSCN', type: 'Select', error: '', initValue: "", forSelectStoreName: ('OrderSCNType') },
            {
                nickName: g('$订单产品类型'),
                field: 'Count',
                type: 'Select',
                error: '',
                forSelectStoreName: ('OrderDetailCount'),
                OnChange(v) {}
            },



            { nickName: g('$收件人邮箱'), field: 'RecipientEmail', type: 'String', error: '' },
            { nickName: g('$排除客户'), field: 'ExcludeCustomerID', type: 'String', error: '' },
            { nickName: g('$付款状态'), field: 'financial_status', type: 'Select', error: '', initValue: "", forSelectStoreName: ('financial_status') },
        ],
        Search2: [
           
            { nickName: g('$订单状态'), field: 'StatusList',IsMultiple:true,  type: 'Select', error: '', isRequired: true, j: { rex: 'n', tips: g("${支付方式}为必填") }, forSelectStoreName: ('ExportOrderStatus') },
        ],
        Table: {
            IsSelectAll: false,
            OnSelectionChange: function(selection) {
                window.rootVue.$set(vueState, GN('OrderTableSelectCheckbox'), selection)

                if (vueState[GN("SearchOrder")] && vueState[GN("SearchOrder")].Records) {
                    if (selection.length == vueState[GN("SearchOrder")].Records.length) {
                        state.Table.IsSelectAll = true;
                    } else {
                        state.Table.IsSelectAll = false;
                    }
                }

            },


            CellStyle: function(d) {
                if (d.columnIndex == 2) {
                    if (vueState[GN("SearchOrder")] && vueState[GN("SearchOrder")].Records && vueState[GN("SearchOrder")].Records[d.rowIndex].LevelMark) {





                        if (vueState[GN("SearchOrder")].Records[d.rowIndex].LevelMark == '#FFFFFF') {
                            return "background:" + vueState[GN("SearchOrder")].Records[d.rowIndex].LevelMark + ";";
                        } else {
                            return "background:" + vueState[GN("SearchOrder")].Records[d.rowIndex].LevelMark + "; color:#fff";
                        }
                    }
                }
            },
            OnExpandChange(row, expandedRows) {

                if (row.BillID > 1 || !row.BillID) {
                    OrderRequest.GetOrder(function(d) {
                        vueObj.$set(row, 'BillID', true)
                        vueObj.$set(row, 'Warehouse', d.Warehouse)
                        vueObj.$set(row, 'OrderReceives', d.OrderReceives)
                        vueObj.$set(row, 'OrderDetails', d.OrderDetails)
                    }, row.ID)
                }

                console.log(row, expandedRows)
            },


            TableColumns: [

                {
                    nickName: ' ',
                    field: '',
                    type: 'selection',
                    Width: 50,
                    fixed: 'left',
                    initValue: false,
                    forSelectStoreName: GN('UploadTableSelectCheckbox'),
                    Selectable(row, index) {
                        return true;
                    }
                },
                { nickName: '#', field: 'expand', type: 'expand', ExpandComponent: ExpandComponent, Width: 50, },
                { nickName: g('$订单号'), field: 'OrderNo', type: 'String', error: '', isRequired: true, j: { rex: 'w', tips: g("${订单单号}为必填") } },
                {
                    nickName: g('$客户编码'),
                    field: 'CusCode',
                    type: 'AddString',
                    initValue: '',
                    AddString(d) {
                        return d.Customer.Customer.CusCode
                    }
                },
                {
                    nickName: g('$业务员'),
                    field: 'salesman',
                    type: 'AddString',
                    initValue: '',
                    // AddString(d) {
                    //     return d.salesman
                    // }
                },

                {
                    nickName: g('$运输方式'),
                    field: 'ChannelInfoID',
                    type: 'AddString',
                    error: '',
                    Width: 250,
                    isRequired: true,
                    j: { rex: 'n', tips: g("${运输方式}为必填") },
                    AddString(data) {
                        return data.ChannelInfo.EnName + "-" + data.ChannelInfo.CnName
                    }
                },
                { nickName: g('$店铺名称'), field: 'ShopName', type: 'String', error: '' },
                { nickName: g('$客户参考号'), field: 'CsRefNo', type: 'String', error: '' },
                { nickName: g('$跟踪号'), field: 'TrackingNo', type: 'String', error: '' },
                {
                    nickName: g('$国家'),
                    field: 'CountryInfo',
                    type: 'AddString',
                    AddString(data) {
                        return data.CountryInfo.EnName + "-" + data.CountryInfo.CnName
                    }
                },

                // { nickName: g('$付款状态'), field: 'Financial_status', type: 'AddString', 
                //     AddString(data) {
                       
                //         if(data.Financial_status==null){
                //             return "paid"
                //         }else{
                //             return data.Financial_status
                //         }
                        
                //     }
                // },

                { nickName: g('$付款状态'), field: 'Financial_status', type: 'StringIcon', iconClassName:"el-icon-warning",iconStyle:"margin-left:5px;font-size:20px;color:red;",
                    AddString(data) {
                        
                                if(data.Financial_status==null){
                                    return "paid"
                                }else{
                                    return data.Financial_status
                                }
                                
                    },
                    isShowIcon(data){
                        if(data.Financial_status=="refund"){
                            return true
                        }else{
                            return false
                        }
                      
                    }
                
                },
                
                { nickName: g('$下单时间'), field: 'CreateTime', type: 'String' },
                { nickName: g('$发货时间'), field: 'DeliveryTime', type: 'String' },
                { nickName: g('$付款时间'), field: 'PlatFormCreateTime', type: 'String' },
                { nickName: g('$提交确认'), field: 'ConfirmTime', type: 'String' },
                { nickName: g('$运输状态'), field: 'AfterShiptag', type: 'String', IsNotShow: true },
                { nickName: g('$操作'), field: 'Operation', type: 'Operation', initValue: '', Width: 200, Fixed: 'right', ClassName: 'FixedRightBorder' },

            ],
            TableIsEdit: true,
            PageSize: 20,
            OnPageChange: function(Index) {
                state.SearchEntity.PageIndex = Index;
                state.SearchPageData();
            
            },
            OnPageSizeOpts: function(pageSize) {
                state.SearchEntity.PageIndex = 1;
                state.SearchEntity.PageSize = pageSize;
                state.SearchPageData();

            },
            TableRowButtons: function() {

                var store = state
                if (store.Table.$TableRowButtons) {
                    return store.Table.$TableRowButtons
                }

                var arr = [];

                if (true) {
                    arr.push({
                        nickName: g('$查看'),
                        buttonType: 'primary',
                        type: 'Button',
                        forClick: function(data) {
                            if (store.ToUpdate) {
                                store.ToUpdate(data)
                            } else {}
                      },

                      CheckShow: function (data) {
                        if (data.OrderStatus== 9) {
                            return false;
                        }
                        return true;
                    },
                    })
                }

                vueObj.$set(store.Table, '$TableRowButtons', arr)
                return store.Table.$TableRowButtons;
            },
        },
        Table2: {
            IsSelectAll: false,

            OnSelectionChange: function(selection) {
                window.rootVue.$set(vueState, GN('OrderTable2SelectCheckbox'), selection)
            },

            TableColumns: [{
                    nickName: ' ',
                    field: '',
                    type: 'selection',
                    Width: 50,
                    fixed: 'left',
                    initValue: false,
                    forSelectStoreName: GN('OrderTable2SelectCheckbox'),
                    SelectAll(selection) {
                        state.Table.IsSelectAll = true;
                    },
                    Selectable(row, index) {
                        return true;
                    }
                },
                { nickName: g('$订单号'), field: 'OrderNo', type: 'String', error: '', isRequired: true, j: { rex: 'w', tips: g("${订单单号}为必填") } },
            ],
        },
        FieldData: [

            {
                nickName: g('$店铺'),
                field: 'ShopCustomerID',
                type: 'Select',
                error: '',
                forSelectStoreName: GN("OrderShopCustomerID"),
                OnChange(d) {
                    if (state.ShopCustomerChange) {
                        state.ShopCustomerChange(d)
                    }
                }
            },
            { nickName: g('$仓库'), field: 'WarehouseID', type: 'Select', error: '', isRequired: true, j: { rex: 'n', tips: g("${仓库}为必填") }, index: -1, forSelectStoreName: GN('OrderWareHousesID') },
            {
                nickName: g('$国家'),
                field: 'Country',
                type: 'Select',
                error: '',
                isRequired: true,
                j: { rex: 'n', tips: g("${国家}为必填") },
                index: -1,
                forSelectStoreName: GN('OrderCountry'),
                OnChange(d) {
                    if (state.ToCountryChange) {
                        state.ToCountryChange(d)
                    } else {}
                }
            },

            { nickName: g('$客户参考号'), field: 'CsRefNo', type: 'String', error: '', index: -1, jj: { rex: 'w', tips: g("${客户参考号}为必填") } },
            { nickName: g('$收件人'), field: 'ConsigneeName', type: 'String', error: '', index: -1, jj: { rex: 'w', tips: g("${收件人}为必填") } },
            { nickName: g('$邮编'), field: 'Zipcode', type: 'String', error: '', index: -1, jj: { rex: 'w', tips: g("${邮编}为必填") } },
            {
                nickName: g('$运输方式'),
                field: 'ChannelInfoID',
                type: 'Select',
                error: '',
                index: -1,
                isRequired: true,
                j: { rex: 'n', tips: g("${运输方式}为必填") },
                forSelectStoreName: GN('OrderChannelInfoID'),
                OnChange(d) {
                    if (state.ToChannelInfoChange) {
                        state.ToChannelInfoChange(d)
                    } else {}
                }
            },

            //{ nickName: g('$发件人'), field: 'Sender', type: 'String', error: '' },
            //{ nickName: g('$发件人地址'), field: 'SendAddress', type: 'String', error: '' },
            //{ nickName: g('$发件人电话'), field: 'SendPhone', type: 'String', error: '' },
            //{ nickName: g('$发件人邮箱'), field: 'SendEmail', type: 'String', error: '' },
            //{ nickName: g('$发件人公司'), field: 'SendCompany', type: 'String', error: '' },

            { nickName: g('$店铺'), field: 'ShopName', type: 'String', error: '', jj: { rex: 'w', tips: g("${店铺}为必填") } },
            { nickName: g('$公司名称'), field: 'CompanyName', type: 'String', error: '', jj: { rex: 'w', tips: g("${公司名称}为必填") } },
            { nickName: g('$收件地址1'), field: 'Address1', type: 'String', error: '', jj: { rex: 'w', tips: g("${收件地址1}为必填") } },
            { nickName: g('$收件地址2'), field: 'Address2', type: 'String', error: '', jj: { rex: 'w', tips: g("${收件地址2}为必填") } },
            { nickName: g('$州'), field: 'Add_State', type: 'String', error: '', jj: { rex: 'w', tips: g("${州}为必填") } },
            { nickName: g('$城市'), field: 'City', type: 'String', error: '', jj: { rex: 'w', tips: g("${城市}为必填") } },
            { nickName: g('$联系电话'), field: 'Contact', type: 'String', error: '', jj: { rex: 'w', tips: g("${联系电话}为必填") } },
            { nickName: g('$邮箱'), field: 'RecipientEmail', type: 'String', error: '', jj: { rex: 'w', tips: g("${邮箱}为必填") } },
            { nickName: g('$票件数'), field: 'BillQty', type: 'String', error: '', isRequired: true, j: { rex: 'n', tips: g("${票件数}为必填") } },
            { nickName: g('$是否需要电子签名'), field: 'IsSignFlag', type: 'Boolean', error: '', initValue: false, forSelectStoreName: 'IsAndNot' },
            { nickName: g('$是否带电'), field: 'IsBatteryFlag', type: 'Boolean', error: '', initValue: false, forSelectStoreName: 'IsAndNot' },
            { nickName: g('$备注'), field: 'CusRemark', type: 'String', error: '' }

        ],

        initPageData() {
            
            vueObj = window.rootVue;      
            var vueState = vueObj.$store.state;
            state = vueObj.$store.state[defaultStoreName];
            var store = state
            if (!store) {
                store = Clone(OrderPage);
                store.Entity = ToSubmitData(ToComponentData(OrderPage.FieldData))
                store.SearchEntity = ToSubmitData(ToComponentData(OrderPage.Search))
                store.IsInit = true;
                vueObj.$set(vueObj.$store.state, OrderPage.storeName, store)
            }
            state = store;
                 
            return store
        },
        SearchPageData(callback) {

            if (!state.SearchEntity.PageSize) {
                state.SearchEntity.PageSize = OrderPage.Table.PageSize
            }

            if (!vueState[GN('SearchOrder')]) {
                vueObj.$set(vueState, GN("SearchOrder"), dc)
            }

            state.SearchEntity.SortField = 51
            state.SearchEntity.SortType = 2

            if (state.SearchEntity.Sort == 1) {
                state.SearchEntity.SortField = 51
                state.SearchEntity.SortType = 1
            }

            if (state.SearchEntity.Sort == 2) {
                state.SearchEntity.SortField = 11
                state.SearchEntity.SortType = 2
                state.SearchEntity.ThenBySortField = [{ SortType: 2, SortField: 51 }]
            }

            if (state.SearchEntity.Sort == 3) {
                state.SearchEntity.SortField = 11
                state.SearchEntity.SortType = 1
                state.SearchEntity.ThenBySortField = [{ SortType: 2, SortField: 51 }]
            }


            if (state.SearchEntity.Sort == 4) {
                state.SearchEntity.SortField = 12
                state.SearchEntity.SortType = 2
                state.SearchEntity.ThenBySortField = [{ SortType: 2, SortField: 51 }]
            }

            if (state.SearchEntity.Sort == 5) {
                state.SearchEntity.SortField = 12
                state.SearchEntity.SortType = 1
                state.SearchEntity.ThenBySortField = [{ SortType: 2, SortField: 51 }]
            }


            if (state.SearchEntity.Sort == 6) {
                state.SearchEntity.SortField = 13
                state.SearchEntity.SortType = 2
                state.SearchEntity.ThenBySortField = [{ SortType: 2, SortField: 51 }]
            }

            if (state.SearchEntity.Sort == 7) {
                state.SearchEntity.SortField = 13
                state.SearchEntity.SortType = 1
                state.SearchEntity.ThenBySortField = [{ SortType: 2, SortField: 51 }]
            }

            state.SearchEntity.IncludePaths = ["Customer.Customer", "CountryInfo", "ChannelInfo", "SubChannelInfo", "ShopCustomer", "ReceiveUser", "DeliveryUser", "Currency", "WeightUnit"]
            state.SearchEntity.IsStatusReport = true;
            if (state.SearchEntity.ONs2) {
                state.SearchEntity.ONs = state.SearchEntity.ONs2.replace(/[ \n，]|,,/g, ",");
                state.SearchEntity.OrderNoList = state.SearchEntity.ONs.split(/[\n,]/g)

                var arr = new window.$LQ(state.SearchEntity.OrderNoList).Select(function(e) {
                    return e
                }).items
                state.SearchEntity.OrderNoList = arr
            }else {
                state.SearchEntity.OrderNoList = null;
            }

 
            OrderRequest.SearchOrder(function(d) {
               
                
               
                vueObj.$set(vueState, GN("SearchOrder"), d)
                
                state.Table.$TableRowButtons = null;


                state.initNextCompanyNextCompanyIDByQ(state.SearchEntity.OrderStatus);

                vueObj.$set(state.Table, '$TableRowButtons', state.Table.TableRowButtons())
                vueObj.$set(state, 'Table', Clone(state.Table))
                if (callback) { callback(d) }
            }, state.SearchEntity)

            return vueState[GN('SearchOrder')]
        },
        // initSendAddress(callback) {
        //     SendAddressRequest.SearchSendAddress(function (d) {
        //         var arr = [];
        //         for (var i of d.Records) {
        //             arr.push(i)
        //         }
        //         vueObj.$set(vueObj.$store.state, GN("OrderSendAddress"), arr)
        //         if (callback) { callback(d) }
        //     }, {
        //             PageSize: 10000,
        //             Status: 1
        //         })
        // },
     

        initOrderChannelInfoID(ChannelAreaRegionCountryID, callback) {

            ChannelInfoRequest.SearchChannelInfo(function(d) {
                var arr = [];
                for (var i of d.Records) {
                    i.Text = i.EnName + "(" + i.CnName + ")";
                    i.Value = i.ID;
                    arr.push(i)
                }
                vueObj.$set(vueObj.$store.state, GN("OrderChannelInfoID"), arr)
                if (callback) { callback(d) }
            }, {
                ChannelAreaRegionCountryID: ChannelAreaRegionCountryID,
                Status: 1,
                PageSize: 10000,
            })

        },

        initShopCustomerShopCustomerID(callback) {

            ShopCustomerRequest.SearchShopCustomerBySearch(function(d) {
                var arr = [];
                for (var i of d.Records) {
                    i.Text = i.ShopName;
                    i.Value = i.value;
                    arr.push(i)
                }
                vueObj.$set(vueObj.$store.state, GN("OrderShopCustomerID"), arr)
                if (callback) { callback(d) }
            }, {
                PageSize: 10000,
            })
        },

        initRegionCountry(callback) {

            RegionRequest.SearchRegion(function(d) {
                var arr = [];
                for (var i of d.Records) {
                    i.Text = i.EnName + "-" + i.CnName;
                    i.Value = i.ID;
                    arr.push(i)
                }

                vueObj.$set(vueObj.$store.state, GN("OrderCountry"), arr)
                if (callback) { callback(d) }
            }, {
                PageSize: 10000,
            })
        },

        GetData(ID, callback) {
            if (ID == 0) {
                return;
            }
            OrderRequest.GetOrder(function(d) {
                var store = state
                vueObj.$set(store, 'Entity', d)
                if (callback) { callback(d) }
            }, ID)
        },
        Update: function(store, callback) {
            if (!store.Entity.ID) { //add
                var entity = ToSubmitEntity(store.Entity, store.FieldData);
                if (CheckByEntity(entity, store.FieldData)) {
                    OrderRequest.AddOrder(function(d) {
                        if (d.Message == "OK") {
                            if (callback) { callback(d) }
                            vueObj.$message.success(g("$操作成功"))
                        } else {
                            vueObj.$message.error(d.Message)
                        }
                    }, entity)
                }
            } else { //update
                var entity = ToSubmitEntity(store.Entity, store.FieldData);
                if (CheckByEntity(entity, store.FieldData)) {
                    OrderRequest.UpdateOrder(function(d) {
                        if (d.Message == "OK") {
                            if (callback) { callback(d) }
                            vueObj.$message.success(g("$操作成功"))
                        } else {
                            vueObj.$message.error(d.Message)
                        }
                    }, entity)
                }
            }
        },

        AddOrderList(OrderList, callback) {
            if (!OrderList || OrderList.length == 0) {
                return;
            }

            OrderRequest.AddOrders(function(d) {
                if (d.Message == "OK") {
                    if (callback) { callback(d) }
                    vueObj.$message.success(g("$操作成功"))
                } else {
                    vueObj.$message.error(d.Message)
                }
            }, OrderList)

        },

        OrderSubmit(IDArr, IsAll, Search, callback) {


            OrderRequest.OrderSubmit(function(d) {
                if (d.Message == "OK") {
                    if (callback) { callback(d) }
                    vueObj.$message.success(g("$操作成功"))
                } else {
                    vueObj.$message.error(d.Message)
                }
            }, { IDArr: IDArr, IsAll: IsAll, Search: Search })
        },
        

        UpdateOrders(IDArr, order, callback) {


            OrderRequest.UpdateOrders(function(d) {
                if (d.Message == "OK") {
                    if (callback) { callback(d) }
                    vueObj.$message.success(g("$操作成功"))
                } else {
                    vueObj.$message.error(d.Message)
                }
            }, { IDArr: IDArr, data: order })

        },

        MergeOrder(IDArr, BaseID, callback) {


            OrderRequest.MergeOrder(function(d) {
                if (d.Message == "OK") {
                    if (callback) { callback(d) }
                    vueObj.$message.success(g("$操作成功"))
                } else {
                    vueObj.$message.error(d.Message)
                }
            }, { IDArr: IDArr, BaseID: BaseID })
        },




        MergeOrder(IDArr, BaseID, callback) {


            OrderRequest.MergeOrder(function(d) {
                if (d.Message == "OK") {
                    if (callback) { callback(d) }
                    vueObj.$message.success(g("$操作成功"))
                } else {
                    vueObj.$message.error(d.Message)
                }
            }, { IDArr: IDArr, BaseID: BaseID })
        },


        initWarehouseWareHousesID(callback) {

            WarehouseRequest.SearchWarehouse(function(d) {
                var arr = [];
                for (var i of d.Records) {
                    i.Text = i.EnName + '-' + i.CnName;
                    i.Value = i.ID;
                    arr.push(i)
                }
                vueObj.$set(vueObj.$store.state, GN("OrderWareHousesID"), arr)
                if (callback) { callback(d) }
            }, {
                PageSize: 10000,
                Status: 1
            })
        },

        ExportOrder(data, callback) {


            OrderRequest.ExportOrder(function(d) {
                if (d.Message == "OK") {
                    if (callback) { callback(d) }
                    vueObj.$message.success(g("$操作成功"))
                } else {
                    vueObj.$message.error(d.Message)
                }
            }, data)
        },
        ExportOrderLess(data, callback) {


            OrderRequest.ExportOrderLess(function(d) {
                if (d.Message == "OK") {
                    if (callback) {
                        callback(d)
                    }
                    vueObj.$message.success(g("$操作成功"))
                } else {
                    vueObj.$message.error(d.Message)
                }
            }, data)
        },

        CopyOrder(No) {

            OrderRequest.CopyOrder(function(d) {
                if (d.Message == "OK") {
                    if (callback) { callback(d) }
                    vueObj.$message.success(g("$操作成功"))
                } else {
                    vueObj.$message.error(d.Message)
                }
            }, { No: No })

        },

        initNextCompanyNextCompanyIDByQ(OrderStatus, callback) {

            ChannelInfoRequest.SearchNextCompanyByQ(function(d) {
                var arr = [];
                for (var i of d.Records) {
                    i.Text = i.EnName + "-" + i.CnName;
                    i.Value = i.ID;
                    arr.push(i)
                }
                vueObj.$set(vueObj.$store.state, GN("OrderSubChannelInfoID"), arr)
                if (callback) {
                    callback(d)
                }
            }, {
                PageSize: 10000,
                OrderStatus: OrderStatus
            })
        },

        initNextCompanyNextCompanyID(callback) {

            ChannelInfoRequest.SearchNextCompany(function(d) {
                var arr = [];
                for (var i of d.Records) {
                    i.Text = i.EnName + "-" + i.CnName;
                    i.Value = i.ID;
                    arr.push(i)
                }
                vueObj.$set(vueObj.$store.state, GN("OrderSubChannelInfoID"), arr)
                if (callback) {
                    callback(d)
                }
            }, {
                PageSize: 10000,
            })
        },

        OrderStatusByVoid(IDArr, callback) {

            OrderRequest.OrderStatusByVoid(function(d) {
                if (d.Message == "OK") {
                    if (callback) { callback(d) }
                    vueObj.$message.success(g("$操作成功"))
                } else {
                    vueObj.$message.error(d.Message)
                }
            }, { IDArr: IDArr })
        },

        MarkingOrder(IDArr, Type, EnName,CnName,callback) {
            OrderRequest.MarkingOrder(function(d) {
                if (d.Message == "OK") {
                    if (callback) { callback(d) }
                    vueObj.$message.success(g("$操作成功"))
                } else {
                    vueObj.$message.error(d.Message)
                }
            }, { IDArr: IDArr, Type: Type ,EnName:EnName,CnName:CnName})
        },


        RemarkOrder(IDArr, Remark, callback) {
            OrderRequest.RemarkOrder(function(d) {
                if (d.Message == "OK") {
                    if (callback) { callback(d) }
                    vueObj.$message.success(g("$操作成功"))
                } else {
                    vueObj.$message.error(d.Message)
                }
            }, { IDArr: IDArr, Remark: Remark })
        },

        OrderPaySubmit(IDArr, IsAll, Search, callback) {

            OrderRequest.OrderPaySubmit(function(d) {
                if (d.Message == "OK") {
                    if (callback) { callback(d) }
                    vueObj.$message.success(g("$操作成功"))
                } else {
                    vueObj.$message.error(d.Message)
                }
            }, { IDArr: IDArr, IsAll: IsAll, Search: Search })

        },

        UploadAfterShip(IDArr, IsAll, Search, callback) {
            OrderRequest.UploadAfterShip(function(d) {
                if (callback) { callback(d) }
            }, { IDArr: IDArr, IsAll: IsAll, Search: Search })
        },


        UpdateShopify(IDArr, IsAll, Search, callback) {
            OrderRequest.UpdateShopify(function(d) {
                if (callback) { callback(d) }
            }, { IDArr: IDArr, IsAll: IsAll, Search: Search })
        },

        UpdateYUNTU(IDArr, callback) {
            OrderRequest.UpdateYUNTU(function(d) {
                if (callback) { callback(d) }
            }, { IDArr: IDArr })
        },
        InterceptOredr(orders, callback) {
            OrderRequest.InterceptOredr(function(d) {
                if (callback) { callback(d) }
            }, { orders: orders })
        },
        TrackingOrder(IDArr, IsAll, Search, callback) {
            OrderRequest.TrackingOrder(function(d) {
                if (callback) { callback(d) }
            }, { IDArr: IDArr, IsAll: IsAll, Search: Search })
        },

        initColorMark(callback) {

            ColorMarkRequest.SearchColorMark(function(d) {
                var arr = [];
                for (var i of d.Records) {
                    i.Text = i.EnName + "-" + i.CnName;
                    i.Value = i.Color;
                    arr.push(i)
                }

                vueObj.$set(vueObj.$store.state, GN("ColorMark"), arr)
           
                if (callback) { callback(d) }
            }, {
                PageSize: 10000,
            })


        },
        SetOrderChoose(){           
            OrderRequest.OrderChoose(function(d){                  
                vueObj.$set(vueObj.$store.state, GN("OrderChoose"), d)                      
            })
        },


        CutOffOrder(IDArr, IsAll, Search, callback) {


            OrderRequest.CutOffOrder(function(d) {
                if (d.Message == "OK") {
                    if (callback) { callback(d) }
                    vueObj.$message.success(g("$操作成功"))
                } else {
                    vueObj.$message.error(d.Message)
                }
            }, { IDArr: IDArr, IsAll: IsAll, Search: Search })
        },

        GetUPSOrderTrackingNo(IDArr, IsAll, Search, callback) {

            OrderRequest.GetUPSOrderTrackingNo(function(d) {
                if (d.Message == "OK") {
                    if (callback) { callback(d) }
                    vueObj.$message.success(g("$操作成功"))
                } else {
                    vueObj.$message.error(d.Message)
                }
            }, { IDArr: IDArr, IsAll: IsAll, Search: Search })
        },

        DeleteOrder(IDArr, IsAll, Search, callback) {

            OrderRequest.DeleteOrder(function(d) {
                if (d.Message == "OK") {
                    if (callback) { callback(d) }
                    vueObj.$message.success(g("$操作成功"))
                } else {
                    vueObj.$message.error(d.Message)
                }
            }, { IDArr: IDArr, IsAll: IsAll, Search: Search })
        },

        UploadBag: {

            Table: {
                OnSelectionChange: function(selection) {
                    window.rootVue.$set(vueState, GN('UploadTableSelectCheckbox'), selection)
                },
                TableColumns: [{
                        nickName: ' ',
                        field: '',
                        type: 'selection',
                        width: 50,
                        fixed: 'left',
                        initValue: false,
                        forSelectStoreName: GN('UploadTableSelectCheckbox'),
                        Selectable(row, index) {
                            return vueState[GN('file_upload')] ? !vueState[GN('file_upload')].data[index].disabled : false;
                        }
                    },
                    { nickName: g('$重量'), field: 'BagsWeight', type: 'String', error: '', isRequired: true, j: { rex: 'w', tips: g("${重量}为必填") } },
                    { nickName: g('$长'), field: 'BagsLenght', type: 'String', error: '', isRequired: true, j: { rex: 'w', tips: g("${长}为必填") } },
                    { nickName: g('$宽'), field: 'BagsWidth', type: 'String', error: '', isRequired: true, j: { rex: 'w', tips: g("${宽}为必填") } },
                    { nickName: g('$高'), field: 'BagsHeight', type: 'String', error: '', isRequired: true, j: { rex: 'w', tips: g("${高}为必填") } },
                    { nickName: 'error', field: '__Error__', type: 'String', error: '', ClassName: "red" },
                ],
            },
            templateurl() {
                window.location = $Urlpath + "/Content/UploadTemplate/OrderBags_upload_template.xls"
            },
            isInitUplaod: false,
            ModalName: g('$包裹导入'),
            ModuleShow: false,
            initUplaod() {

                var store = state
                var vueObj = window.rootVue;

                if ($("#" + 'UploadBag_file_upload label')[0]) {
                    return;
                }

                store.UploadBag.isInitUplaod = true;
                $Upload($("#" + 'UploadBag_file_upload'), function(file, data) {
                    var i = 0;
                    for (const e of data.data) {
                        e["__Error__"] = e["__Error__"] ? e["__Error__"] : "";

                        var r;
                        r = ObjectCheck({ rex: 'd', tips: g("${重量}为必填"), max: 50 }, e.BagsWeight);
                        if (!r.IsCheck) {
                            e["__Error__"] += "," + r.error
                        }

                        e.BagsWeight_LB = ((e.BagsWeight ? e.BagsWeight : 0) * 2.2).toFixed(2);

                        r = ObjectCheck({ rex: 'd', tips: g("${长}为必填"), max: 50 }, e.BagsLenght);
                        if (!r.IsCheck) {
                            e["__Error__"] += "," + r.error
                        }

                        r = ObjectCheck({ rex: 'd', tips: g("${宽}为必填") }, e.BagsWidth);
                        if (!r.IsCheck) {
                            e["__Error__"] += "," + r.error
                        }

                        r = ObjectCheck({ rex: 'd', tips: g("${高}为必填") }, e.BagsHeight);
                        if (!r.IsCheck) {
                            e["__Error__"] += "," + r.error
                        }

                        e.RID = i;
                        i++;
                        if (e["__Error__"]) {
                            e.disabled = true;
                        }
                    }

                    vueObj.$set(vueState, GN('file_upload'), data)

                }, $Urlpath + "/Upload/UploadOrderBags", $UploadSetting.Excel)

            },
            show() {
                state.UploadBag.ModuleShow = true;
                setTimeout(function() {
                    state.UploadBag.initUplaod()
                }, 500)
            }
        },

        UploadStandardOrder: { //上传标准模板
            Table: {
                TableIsEdit: true,
                OnSelectionChange: function(selection) {
                    window.rootVue.$set(vueState, GN('UploadTableSelectCheckbox'), selection)
                },
                $TableRowButtons: [{
                    nickName: g('$查看物品信息'),
                    buttonType: 'warning',
                    type: 'Button',
                    CheckShow: function(data) {
                        return true;
                    },
                    forClick: function(data) {
                        window.rootVue.$set(vueState, GN('SeeOrderDetails'), data.OrderDetails)
                        state.UploadStandardOrder.ModuleShow2 = true;
                    }
                }],
                TableColumns: [{
                        nickName: ' ',
                        field: '',
                        type: 'selection',
                        width: 50,
                        fixed: 'left',
                        initValue: false,
                        forSelectStoreName: GN('UploadTableSelectCheckbox'),
                        Selectable(row, index) {
                            return vueState[GN('UploadStandardOrder_file_upload')] ? !vueState[GN('UploadStandardOrder_file_upload')].data[index].disabled : false;
                        }
                    },
                    { nickName: g('$运输方式'), field: 'ChannelInfoName', type: 'String', error: '', isRequired: true, j: { rex: 'n', tips: g("${运输方式}为必填") } },
                    { nickName: g('$收件人'), field: 'ConsigneeName', type: 'String', error: '', isRequired: true, j: { rex: 'w', tips: g("${订单单号}为必填") } },
                    { nickName: g('$收件地址'), field: 'Address1', type: 'String', error: '' },
                    { nickName: g('$收件人国家'), field: 'CountryName', type: 'String', error: '' },
                    { nickName: 'error', field: '__Error__', type: 'String', error: '', class: "red", ClassName: "red" },
                    { nickName: g('$操作'), field: 'Operation', type: 'Operation', initValue: '', Width: 150, Fixed: 'right', ClassName: 'FixedRightBorder' },
                ],
            },

            Table2: {
                TableColumns: [
                    { nickName: '#', field: '', type: 'index', width: 50, fixed: 'left', initValue: false, forSelectStoreName: GN('UploadTableSelectCheckbox') },
                    { nickName: g('$SKU'), field: 'SKU', type: 'String', error: '' },
                    { nickName: g('$海关申报英文名称'), field: 'CnName', type: 'String', error: '' },
                    { nickName: g('$海关申报中文名称'), field: 'EnName', type: 'String', error: '', isRequired: true, j: { rex: 'w', tips: g("${EnName}为必填") } },
                    { nickName: g('$海关货物编码'), field: 'CustomcCode', type: 'String', error: '' },
                    { nickName: g('$申报品数量'), field: 'Quantity', type: 'String', error: '', isRequired: true, j: { rex: 'n', tips: g("${数量}为必填") } },
                    { nickName: g('$申报品价值'), field: 'SingleWeight', type: 'String', error: '', isRequired: true, j: { rex: 'd', tips: g("${申报品价值}为必填") } },
                    { nickName: g('$产地'), field: 'SinglePrice', type: 'String', error: '', isRequired: true, j: { rex: 'd', tips: g("${产地}为必填") } },
                ],
            },

            templateurl() {
                window.location = $Urlpath + "/Content/UploadTemplate/OrderByStandard_upload_template.xls"
            },
            isInitUplaod: false,
            ModalName: g('$标准模板-订单批量新建'),
            ModuleShow: false,
            ModuleShow2: false,
            initUplaod() {

                var store = state
                var vueObj = window.rootVue;

                if ($("#" + 'UploadStandardOrder_file_upload label')[0]) {
                    return;
                }

                $Upload($("#" + 'UploadStandardOrder_file_upload'), function(file, data) {
                    var i = 0;
                    for (const e of data.data) {
                        e["__Error__"] = e["__Error__"] ? e["__Error__"] : "";

                        var r;
                        r = ObjectCheck({ rex: 'w', tips: g("${运输方式}为必填"), max: 50 }, e.ChannelInfoName);
                        if (!r.IsCheck) {
                            e["__Error__"] += "," + r.error
                        }

                        r = ObjectCheck({ rex: 'w', tips: g("${收件人}为必填"), max: 50 }, e.ConsigneeName);
                        if (!r.IsCheck) {
                            e["__Error__"] += "," + r.error
                        }

                        r = ObjectCheck({ rex: 'w', tips: g("${收件人国家}为必填") }, e.CountryName);
                        if (!r.IsCheck) {
                            e["__Error__"] += "," + r.error
                        }

                        r = ObjectCheck({ rex: 'w', tips: g("${地址行1}为必填") }, e.Address1);
                        if (!r.IsCheck) {
                            e["__Error__"] += "," + r.error
                        }

                        r = ObjectCheck({ rex: 'w', tips: g("${城市}为必填") }, e.City);
                        if (!r.IsCheck) {
                            e["__Error__"] += "," + r.error
                        }

                        r = ObjectCheck({ rex: 'w', tips: g("${省}为必填") }, e.Add_State);
                        if (!r.IsCheck) {
                            e["__Error__"] += "," + r.error
                        }

                        r = ObjectCheck({ rex: 'w', tips: g("${邮编}为必填") }, e.Zipcode);
                        if (!r.IsCheck) {
                            e["__Error__"] += "," + r.error
                        }

                        r = ObjectCheck({ rex: 'n', tips: g("${票件数}为必填") }, e.BillQty);
                        if (!r.IsCheck) {
                            e["__Error__"] += "," + r.error
                        }

                        e.RID = i;
                        i++;

                        if (e["__Error__"]) {
                            e.disabled = true;
                        }

                    }

                    vueObj.$set(vueState, GN('UploadStandardOrder_file_upload'), data)

                }, $Urlpath + "/Upload/UploadOrderStandardTemplate", $UploadSetting.Excel)

            },
            show() {
                state.UploadStandardOrder.ModuleShow = true;
                setTimeout(function() {
                    state.UploadStandardOrder.initUplaod()
                }, 500)
            }
        },

        UploadTrackingNos: { //更新跟踪号
            Table: {
                TableIsEdit: true,
                OnSelectionChange: function(selection) {
                    window.rootVue.$set(vueState, GN('UploadTableSelectCheckboxTrackingNos'), selection)
                },
                TableColumns: [{
                        nickName: ' ',
                        field: '',
                        type: 'selection',
                        width: 50,
                        fixed: 'left',
                        initValue: false,
                        forSelectStoreName: GN('UploadTableSelectCheckboxTrackingNos'),
                        Selectable(row, index) {
                            return vueState[GN('UploadTrackingNos_file_upload')] ? !vueState[GN('UploadTrackingNos_file_upload')].data[index].disabled : false;
                        }
                    },
                    { nickName: g('$_订单号'), field: 'OrderNo', type: 'String', error: '', isRequired: true, j: { rex: 'n', tips: g("${订单号}为必填") } },
                    { nickName: g('$_跟踪号'), field: 'TrackingNo', type: 'String', error: '', isRequired: true, j: { rex: 'w', tips: g("${跟踪号}为必填") } },
                    { nickName: 'error', field: '__Error__', type: 'String', error: '', class: "red", ClassName: "red" },
                ],
            },

            templateurl() {
                window.location = $Urlpath + "/Content/UploadTemplate/UploadTrackingNos_upload_template.xls"
            },
            isInitUplaod: false,
            ModalName: g('$批量更新跟踪号'),
            ModuleShow: false,
            ModuleShow2: false,
            initUplaod() {

                var store = state
                var vueObj = window.rootVue;

                if ($("#" + 'UploadTrackingNos_file_upload label')[0]) {
                    return;
                }

                $Upload($("#" + 'UploadTrackingNos_file_upload'), function(file, data) {
                    var i = 0;
                    for (const e of data.data) {
                        e["__Error__"] = e["__Error__"] ? e["__Error__"] : "";

                        var r;
                        r = ObjectCheck({ rex: 'w', tips: g("${订单号}为必填"), max: 50 }, e.OrderNo);
                        if (!r.IsCheck) {
                            e["__Error__"] += "," + r.error
                        }

                        r = ObjectCheck({ rex: 'w', tips: g("${跟踪号}为必填"), max: 50 }, e.TrackingNo);
                        if (!r.IsCheck) {
                            e["__Error__"] += "," + r.error
                        }

                        e.RID = i;
                        i++;

                        if (e["__Error__"]) {
                            e.disabled = true;
                        }

                    }

                    vueObj.$set(vueState, GN('UploadTrackingNos_file_upload'), data)

                }, $Urlpath + "/Upload/UploadTrackingNos", $UploadSetting.Excel)

            },
            show() {
                state.UploadTrackingNos.ModuleShow = true;
                setTimeout(function() {
                    state.UploadTrackingNos.initUplaod()
                }, 500)
            },
            Update(datas, callback) {

                OrderRequest.UploadTrackingNos(function(d) {
                    if (d.Message == "OK") {
                        if (callback) { callback(d) }
                        vueObj.$message.success(g("$操作成功"))
                    } else {
                        vueObj.$message.error(d.Message)
                    }
                }, datas)

            }
        }

    }

    return OrderPage;
}



// WEBPACK FOOTER //
// ./src/config/Order/OrderListConfig.js